import { Fragment, type ReactNode } from 'react';

/**
 * Chrome classifica un form come "modulo carta di credito" — e propone
 * l'autofill dei metodi di pagamento — quando l'euristica trova nei label/name
 * dei campi parole come "numero"/"number" (numero carta) accanto a
 * "scadenza"/"expiry" (scadenza carta). L'attributo `autocomplete` (anche
 * "off") viene IGNORATO da questo rilevamento.
 *
 * Difesa affidabile: spezzare la keyword inserendo un separatore dentro un
 * `<span style="display:none">`. Il carattere finisce nel `textContent` letto
 * dall'euristica di Chrome (quindi "Numero" non matcha più), ma resta ESCLUSO
 * dall'accessible name (l'algoritmo accname salta i nodi `display:none`): la
 * label resta "Numero Lotto" per screen reader, `getByLabel` e
 * `getByRole({ name })`. La parte visibile è identica perché il separatore è
 * nascosto. Opera sulla stringa già tradotta → i18n-safe.
 */
const PAYMENT_KEYWORDS_SPLIT = /(numero|number|scadenza|expiration|expiry)/gi;
const IS_PAYMENT_KEYWORD = /^(numero|number|scadenza|expiration|expiry)$/i;

export function breakPaymentKeywords(label: string): ReactNode {
  // split con gruppo catturante: i match restano come segmenti separati.
  const segments = label.split(PAYMENT_KEYWORDS_SPLIT);
  let offset = 0;
  return segments.map((segment) => {
    // offset = posizione del segmento nella stringa: key stabile e unica,
    // senza usare l'indice dell'array (i segmenti non si riordinano mai).
    const key = `seg-${offset}`;
    offset += segment.length;
    if (!IS_PAYMENT_KEYWORD.test(segment)) {
      return segment;
    }
    return (
      <Fragment key={key}>
        {segment.slice(0, 2)}
        <span style={{ display: 'none' }}>-</span>
        {segment.slice(2)}
      </Fragment>
    );
  });
}
